import React from "react";
import DataTable from "../../../components/DataTable";

const DegreeTypes = () => (
  <DataTable
    title="Degree Types"
    apiPath="/api/admin/master/degree-types"
    columns={[
      { key: "id", label: "ID" },
      { key: "name", label: "Name" },
    ]}
    formFields={[
      { key: "name", label: "Name (e.g. UG, PG)", required: true },
    ]}
  />
);

export default DegreeTypes;
